<form class="setup-step" [formGroup]="form" (ngSubmit)="onSubmit()">
  @if (pageState() === 'verifying') {
  <div
    class="licences__state d-flex flex-column align-items-center justify-content-center text-center py-5 gap-3"
  >
    <mat-spinner diameter="40"></mat-spinner>
  </div>
  }

  @if (pageState() === 'error') {
  <div
    class="licences__state d-flex flex-column align-items-center justify-content-center text-center py-5 gap-3"
  >
    <mat-icon class="licences__state-icon--error icon-lg">error_outline</mat-icon>
    <p class="text-body-secondary mb-0">{{ errorMessage() }}</p>
    <div class="d-flex gap-3">
      <button type="button" mat-stroked-button class="px-4 rounded-full" (click)="onBack()">
        <mat-icon>arrow_back</mat-icon>
        {{ 'onboarding.setup.licences.back' | translate }}
      </button>
      <button
        type="button"
        mat-flat-button
        color="primary"
        class="px-4 rounded-full"
        (click)="retry()"
      >
        <mat-icon>refresh</mat-icon>
        {{ 'onboarding.setup.connectIntune.tryAgain' | translate }}
      </button>
    </div>
  </div>
  }

  @if (pageState() === 'ready') { @if (preview(); as p) {
  <div class="text-center my-2 setup-step__header">
    <h1 class="mb-1">{{ 'onboarding.setup.licences.title' | translate }}</h1>
    <p class="m-0">{{ 'onboarding.setup.licences.subtitle' | translate }}</p>
  </div>

  <div class="licences__panel mx-auto">
    <div class="av-content-box">
      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
        <mat-label>{{ 'onboarding.setup.licences.userLicencesLabel' | translate }}</mat-label>
        <input
          matInput
          type="number"
          inputmode="numeric"
          step="1"
          [min]="minUserLicences"
          formControlName="user_licences"
        />
        <mat-icon matPrefix>person</mat-icon>
        <mat-hint>{{ 'onboarding.setup.licences.userLicencesHint' | translate }}</mat-hint>
        @if (form.get('user_licences')?.touched && form.get('user_licences')?.invalid) {
        <mat-error>{{ 'onboarding.setup.licences.userLicencesError' | translate }}</mat-error>
        }
      </mat-form-field>

      @if (agentAvailable()) {
      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
        <mat-label>{{ 'onboarding.setup.licences.deviceLicencesLabel' | translate }}</mat-label>
        <input
          matInput
          type="number"
          inputmode="numeric"
          step="1"
          [min]="minDeviceLicences"
          formControlName="device_licences"
        />
        <mat-icon matPrefix>devices</mat-icon>
        <mat-hint>{{ 'onboarding.setup.licences.deviceLicencesHint' | translate }}</mat-hint>
        @if (form.get('device_licences')?.touched && form.get('device_licences')?.invalid) {
        <mat-error>{{ 'onboarding.setup.licences.deviceLicencesError' | translate }}</mat-error>
        }
      </mat-form-field>
      }

      <div class="licences__total d-flex justify-content-between align-items-center gap-3">
        <span class="licences__total-label">{{
          'onboarding.setup.licences.monthlyTotal' | translate
        }}</span>
        <span class="licences__total-amount">{{ money(monthlyTotal(), p.currency) }}</span>
      </div>
    </div>

    @if (errorMessage()) {
    <div class="av-alert av-alert--error d-flex align-items-center gap-2 mt-3">
      <mat-icon>error</mat-icon>
      <span class="small">{{ errorMessage() }}</span>
    </div>
    }

    <div class="d-flex justify-content-between align-items-center gap-3 mt-4">
      <button type="button" mat-stroked-button class="px-4 rounded-full" (click)="onBack()">
        <mat-icon>arrow_back</mat-icon>
        {{ 'onboarding.setup.licences.back' | translate }}
      </button>

      @if (isSubmitting()) {
      <button mat-flat-button color="primary" type="submit" disabled class="px-4 rounded-full">
        <mat-spinner diameter="20" class="d-inline-block me-2"></mat-spinner>
        {{ 'onboarding.setup.licences.continue' | translate }}
      </button>
      } @else {
      <button mat-flat-button color="primary" type="submit" class="px-4 rounded-full">
        {{ 'onboarding.setup.licences.continue' | translate }}
        <mat-icon iconPositionEnd>arrow_forward</mat-icon>
      </button>
      }
    </div>
  </div>
  } }
</form>
